import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/backend/api';

const plainApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// No interceptors – so 401 won't redirect
export default plainApi;